$(document).ready(() => {
    const initProductSliders = () => {
        const containers = document.querySelectorAll('.desktop-only .hvg-productSlider-smooth.swiper')
        if (containers.length > 0) {
            containers.forEach(container => {
                const nextBtn = container.querySelector('.hvg-productSlider-smooth.swiper>.swiper-button-next');
                const prevBtn = container.querySelector('.hvg-productSlider-smooth.swiper>.swiper-button-prev');
                const progressBar = container.querySelector('.hvg-productSlider-smooth.swiper>.swiper-pagination')
                const swiper = new Swiper(container, {
                    speed: 3000,
                    centeredSlides: false,
                    spaceBetween: 20,
                    slidesPerView: "auto",
                    pagination: {
                        el: progressBar,
                        type: "progressbar"
                    },
                    navigation: {
                        nextEl: nextBtn,
                        prevEl: prevBtn,
                    },
                    autoplay: {
                        disableOnInteraction: false,
                        delay: 0,
                        stopOnLastSlide: true,
                        enabled: false
                    },

                })

                nextBtn.addEventListener("mouseenter", () => {
                    let isPlaying = swiper.params.autoplay.reverseDirection === false && swiper.animating
                    if (!isPlaying) {
                        swiper.params.autoplay.enabled = true;
                        swiper.params.autoplay.reverseDirection = false;
                        swiper.update();
                        swiper.autoplay.start();
                    }

                });
                nextBtn.addEventListener("mouseleave", () => {
                    swiper.autoplay.stop();
                });
                prevBtn.addEventListener("mouseenter", () => {
                    let isPlaying = swiper.params.autoplay.reverseDirection === true && swiper.animating
                    if (!isPlaying) {
                        swiper.params.autoplay.enabled = true;
                        swiper.params.autoplay.reverseDirection = true;
                        swiper.update();
                        swiper.autoplay.start();
                    }
                });
                prevBtn.addEventListener("mouseleave", () => {
                    swiper.autoplay.stop();
                });

                nextBtn.addEventListener("click", () => {
                    try {
                        const nextIndex = Math.min(swiper.activeIndex + 4,swiper.slides.length - 4)
                        swiper.slideTo(nextIndex,500);
                    } catch (error) {
                        console.log("?? swiper slideTo error", error)
                    }
                });

                prevBtn.addEventListener("click", () => {
                    try {
                        const prevIndex = Math.max(swiper.activeIndex - 4, 0)
                        swiper.slideTo(prevIndex,500);
                    } catch (error) {
                        console.log("?? swiper slideTo error", error)
                    }
                    
                });
            })

        }
    }
    initProductSliders();
})
